export default function exhaustiveCheck(_param?: never): never {
  throw new Error("Should not reach here");
}
